import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime, FormattedDate } from 'react-intl';

import ThumbnailPreviewCertificateDownload from './ThumbnailPreviewCertificateDownload';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { RECHECK_APPROVED, RECHECK_REJECTED, RECHECK_REQUESTED, RECHECK } from '../../../utils/variables';

import EventAvailableRoundedIcon from '@material-ui/icons/EventAvailableRounded';
import TimerRoundedIcon from '@material-ui/icons/TimerRounded';
import CropOriginalRoundedIcon from '@material-ui/icons/CropOriginalRounded';
import SyncProblemRoundedIcon from '@material-ui/icons/SyncProblemRounded';

const ThumbnailPreviewAccountDetails = (props) => {
  const {
    photoSgId,
    photoNodeId,
    shotDate,
    originalUrl,
    socialMediaUrl,
    startNumbers,
    restartState,
    uploadRestarted,
    onRequestHighResolutionPhoto,
    isFaceSearchEvent,
    hasCertificates,
    eventSgId,
    recheckRequestedAt,
    recheckStatus,
    onGoToAccountEventPage,
    recheckHasOrder,
    listType
  } = props;

  return (
    <div className="thumbnail-preview-details">
      <div className="row">
        <div className="col-xs-16 col-sm-6">
          <div className="thumbnail-preview-shortInfo ">
            <CropOriginalRoundedIcon />
            <span>{photoSgId}</span>
          </div>
          {shotDate && (
            <div className="thumbnail-preview-shortInfo ">
              <TimerRoundedIcon />
              <FormattedTime
                value={new Date(shotDate)}
                timeZone="UTC"
                hour="2-digit"
                minute="2-digit"
                second="2-digit"
              />
            </div>
          )}
          {recheckRequestedAt && (
            <div className="thumbnail-preview-shortInfo ">
              <EventAvailableRoundedIcon />
              <span>
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewEventDetails.recheckRequestTime"
                  defaultMessage="Recheck requested"
                />{' '}
                <FormattedDate
                  value={new Date(recheckRequestedAt)}
                  day="numeric"
                  month="numeric"
                  year="numeric"
                  timeZone="UTC"
                />
                {', '}
                <FormattedTime
                  value={new Date(recheckRequestedAt)}
                  timeZone="UTC"
                  hour="2-digit"
                  minute="2-digit"
                />
              </span>
            </div>
          )}
        </div>
        <div className="thumbnail-preview-account-event-actions col-xs-16 col-sm-7 col-sm-offset-3">
          {listType === RECHECK && (
            <>
              {recheckStatus === RECHECK_REQUESTED && (
                <button className="btn-default primary-new full-width" disabled={true}>
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewAccountDetails.actions.recheckInProgress"
                    defaultMessage="In progress"
                  />
                </button>
              )}
              {recheckStatus === RECHECK_REJECTED && (
                <button className="btn-default secondary-new full-width" disabled={true}>
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewAccountDetails.actions.recheckRejected"
                    defaultMessage="Rejected"
                  />
                </button>
              )}
              {recheckStatus === RECHECK_APPROVED && recheckHasOrder && (
                <>
                  <button
                    className="btn-default primary-new full-width"
                    onClick={() => onGoToAccountEventPage()}
                  >
                    <FormattedMessageWrappedInSpan
                      id="thumbnailPreviewAccountDetails.actions.goToEvent"
                      defaultMessage="Go to order"
                    />
                  </button>
                </>
              )}
            </>
          )}
          {originalUrl &&
            (listType != RECHECK ||
              (listType === RECHECK && recheckStatus === RECHECK_APPROVED)) && (
              <a href={originalUrl} download>
                <button className="btn-default primary-new full-width">
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewAccountDetails.actions.downloadHighResolution"
                    defaultMessage="Download high resolution"
                  />
                </button>
              </a>
            )}
          {!originalUrl &&
            restartState == 'can_restart' &&
            !uploadRestarted &&
            (listType != RECHECK ||
              (listType === RECHECK && recheckStatus === RECHECK_APPROVED)) && (
              <button
                className="btn-default secondary-new full-width"
                onClick={onRequestHighResolutionPhoto}
              >
                <FormattedMessageWrappedInSpan
                  id="accountEventPage.requestHighResolution"
                  defaultMessage="Request high resolution"
                />
              </button>
            )}
          {socialMediaUrl &&
            (listType != RECHECK ||
              (listType === RECHECK &&
                recheckStatus === RECHECK_APPROVED &&
                recheckHasOrder)) && (
              <a href={socialMediaUrl} download>
                <button className="btn-default primary-new full-width">
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewAccountDetails.actions.downloadSocialMediaResolution"
                    defaultMessage="Download Social Media Resolution"
                  />
                </button>
              </a>
            )}
          {hasCertificates && originalUrl && listType != RECHECK && (
            <ThumbnailPreviewCertificateDownload
              photoNodeId={photoNodeId}
              startNumbers={startNumbers}
              isFaceSearchEvent={isFaceSearchEvent}
              eventSgId={eventSgId}
            />
          )}
          {!originalUrl && restartState == 'processing' && (
            <span className="thumbnail-preview-info-about-processing">
              <SyncProblemRoundedIcon />
              <FormattedMessageWrappedInSpan
                id="thumbnailPreviewAccountDetails.highResolutionsailableSoon"
                defaultMessage="This photo will be available in high resolution soon. Then you will have additional actions available here."
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

ThumbnailPreviewAccountDetails.propTypes = {
  photoSgId: PropTypes.number,
  photoNodeId: PropTypes.string,
  shotDate: PropTypes.string,
  socialMediaUrl: PropTypes.string,
  originalUrl: PropTypes.string,
  restartState: PropTypes.string,
  uploadRestarted: PropTypes.bool,
  startNumbers: PropTypes.array,
  onRequestHighResolutionPhoto: PropTypes.func,
  isFaceSearchEvent: PropTypes.bool,
  hasCertificates: PropTypes.bool,
  eventSgId: PropTypes.number,
  recheckRequestedAt: PropTypes.string,
  recheckStatus: PropTypes.string,
  onGoToAccountEventPage: PropTypes.func,
  recheckHasOrder: PropTypes.bool,
  listType: PropTypes.string,
};

export default ThumbnailPreviewAccountDetails;
